import { render, staticRenderFns } from "./AutoSide.vue?vue&type=template&id=46dff13f&scoped=true"
import script from "./AutoSide.vue?vue&type=script&lang=js"
export * from "./AutoSide.vue?vue&type=script&lang=js"
import style0 from "./AutoSide.vue?vue&type=style&index=0&id=46dff13f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_6szsw7whnsew6zajutnmcgkloi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dff13f",
  null
  
)

export default component.exports